// components/Header.tsx
import React, { useCallback, useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from '../../redux/hook.ts';
import { setSession } from '../../redux/sessionSlice.ts';
import { setFSession, setFUser } from '../../redux/facilitatorSessionSlice.ts';
import { setTeam } from '../../redux/teamSlice.ts';
import '../../styles/header.css';
import { setUser } from '../../redux/userSlice.ts';
import LogoutIcon from '@mui/icons-material/Logout';

const MenuBar: React.FC = () => {
  const userSession = useAppSelector((state) => state.session.session);
  const fSession = useAppSelector((state) => state.fSession.session);
  const user = useAppSelector((state) => state.user.user);
  const fUser = useAppSelector((state) => state.fSession.user);

  const dispatch = useAppDispatch();
  const [userName, setUserName] = useState<string | undefined>("");
  const [currentSessionId, setSessionId] = useState<number | undefined>(-1);

  const handleLogout = () => {
    dispatch(setSession({ sessionId: -1, teamId: -1, userId: -1, gaminarCode: '' }));
    dispatch(setTeam({ id: -1, teamName: '', backgroundImage: '', categoryId: -1 }));
    dispatch(setUser({ email: '', userName: '' }));
    setUserName("");
    setSessionId(-1);
    if (window.location.href.trim().toLowerCase().includes('facilitator')) {
      const gaminarCode = fSession?.gaminarCode;
      const fEmail = fUser?.email;
      dispatch(setFUser({ email: '', userName: '' }));
      dispatch(setFSession({ gaminarCode: '', sessionId: -1, userName: '' }));
      setTimeout(() => {
        window.location.href = `/Login?sessionCode=${gaminarCode}&email=${fEmail}`;
      }, 100);
    }
    else {
      const gaminarCodeUser = userSession?.gaminarCode;
      const fEmail = fUser?.email;
      dispatch(setUser({ email: '', userName: '' }));
      dispatch(setFUser({ email: '', userName: '' }));
      dispatch(setSession({ gaminarCode: '', sessionId: -1, teamId: -1, userId: -1 }));
      setTimeout(() => {
        window.location.href = `/Login?sessionCode=${gaminarCodeUser}&email=${fEmail}`;
      }, 100);
    }
  };

  const setInitialValues = useCallback(() => {
    if (window.location.href.trim().toLowerCase().includes('facilitator')) {
      console.log("USER", fUser);
      setUserName(fUser?.userName);
      setSessionId(fSession?.sessionId);
    } else {
      setUserName(user?.userName);
      setSessionId(userSession?.sessionId);
    }
  }, [fUser, fSession, user, userSession]); 

  useEffect(() => {
    setInitialValues();
  }, [setInitialValues]); 


  return (
    <header className="header">
      <div className="header__left">
        <img src="/logo.png" alt="Logo" className="header__logo" />
        <h1 className="header__title">Council of the Marble Stars</h1>
      </div>
      {currentSessionId !== undefined && currentSessionId >= 0 && (
        <div className="header__right">
          <span className="header__logout" style={{ "paddingRight": "25px" }}>{userName}</span>
          {userName !== "" ? (<button onClick={handleLogout} className="header__logout">
            <LogoutIcon>Logout</LogoutIcon>
          </button>) : (<></>)}
        </div>
      )}
    </header>
  );
};

export default MenuBar;
